import React, { useEffect, useState } from "react";
import styles from './MarketingScreenNew.module.css'
import BulkMessageImage from '../../Assets/Images/bulk-mgs-image.webp'
import BlueTickImage from '../../Assets/Images/blue-tick-image.webp'
import DataSecurityImage from '../../Assets/Images/data-security-image.webp'
import AutoSendImage from '../../Assets/Images/autosend-message-image.webp'
import MessageTemplateImage from '../../Assets/Images/message-template-image.webp'
import { connect, useDispatch } from "react-redux";
import {fetchDbConstants} from "../../Services/marketingAutomation"
import moment from "moment"
import { url } from '../../Values/constants';
import axiosHandler from "../../Services/axiosHandler";
import { createOrder, pgiAutoLogin } from "../../Services/pgi";
import { pushToGA,googleAnalytics } from '../../Services/users';
import AutomaticBillSetUpContent from "../AutomaticBillSetUpContent/AutomaticBillSetUpContent";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import AutomaticBillPayementContent from "../AutomaticBillPayementContent/AutomaticBillPayementContent";
import GSTModal from "../GSTModal/GSTModal";
import { readproPackagePurchaseViaPGI } from "../../Services/pgi";
interface MarketingScreenBannerProps { 
    user?: any;
	history?:any;
	organizationData?: any; 
	freeTrialPackage: boolean
}

const MarketingScreenBanner: React.FC<MarketingScreenBannerProps> = ({ user,
	history,
	organizationData,
	freeTrialPackage
}) => {
    

    const [roiDates, setRoiDates] = useState([
        // "Top agents are achieving",
        // "50% higher conversion with",
        // " ",
        // "WhatsApp Business on ReadPro"
    ]);
    const [roiDatesGA, setRoiDatesGA] = useState([]);
    const [roiDay, setRoiDay] = useState<string>("");
    const [token,setToken] = useState<any>()
     const [gst, setGst] = useState<any>();
      const [originalPrice, setOriginalPrice] = useState();
      const [packageId, setPackageId] = useState();
      const [isRecurringPay, setIsRecurringPay] = useState<any>("N");
       const [whatsappRechangePlan, setWhatsappRechangePlan] = useState([
            {
              id:"",
              isTopup: false,
              discountedValue: "",
              originalValue: "",
              discountPercent: "",
              validity: "",
              balance: "",
              packageId:"",
            }
          ]);

     const [finalwhatsappRechangePlan, setFinalWhatsappRechangePlan] = useState([
            {
              id:"",
              isTopup: false,
              discountedValue: "",
              originalValue: "",
              discountPercent: "",
              validity: "",
              balance: "",
              packageId:"",
            }
          ]);
    const [activeFilters, setActiveFilters] = useState<string[]>(["Recharge"]);
    const [defaultPackage, setDefaultPackage] = useState<any>();
    const [offerPrice, setOfferPrice] = useState();
    const [balance, setBalance] = useState();
    const [val, setVal] = useState();
    const [discountVal, setdiscountVal] = useState();
    const [openTryAutoPayModal, setOpenTryAutoPayModal] = useState<boolean>(false);
    const [openGstModal, setOpenGstModal] = useState<boolean>(false);
    const [openSetUpAutoPayModal, setOpenSetUpAutoPayModal] = useState<boolean>(false);
    const [recr, setRecr] = useState<any>();
    const [freePack, setFreePack] = useState<any>();
    const dispatcher = useDispatch();
    
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data: any = await fetchDbConstants(["roiDates"]);
        if (data && data[0]?.data?.[0]) {
          const currentDay = moment().format("dddd");

          setRoiDay(currentDay);

          const roiDatesValue = data[0].data[0][currentDay];
          if (roiDatesValue !== undefined) {
            setRoiDates(roiDatesValue);
            setRoiDatesGA(roiDatesValue)
          }
        }
      } catch (error: any) {
        // console.log("Error fetching ROI dates:", error.message);
      }
    };

    fetchData();
  }, []);

    const filterData = (data: any[], activeFilters: string[]) => {
        if (activeFilters.includes("Topup") && activeFilters.includes("Recharge")) {
          // Return all data if both filters are active
          // console.log(data);
          return data;
        }
      
        if (activeFilters.includes("Topup")) {
          // Filter data where isTopup is true
          const filteredData = data.filter(item => item.isTopup === true);
          // console.log(filteredData);
          return filteredData;
        }
      
        // Otherwise, filter data where isTopup is false
        const filteredData = data.filter(item => item.isTopup === false);
        // console.log(filteredData);
        return filteredData;
      };


      useEffect(()=>{
          readProductList()
         },[user])

    const readProductList = async () => {
        // const apiUrl = url+"/pgi/readProductList";
    
        const apiUrl =url+"/pgi/readProductList"
    
        const payload = {
              soid: user.user_super_oid,
        };
      
        try {
          // console.log(" payload:", payload);
      
          const response = await axiosHandler.post(apiUrl, payload);
    
          // console.log("response",response.data.responsePayloadData.pgiRefId)
          const data = response.data;
        //   console.log("data.data",data.data)
          setWhatsappRechangePlan(data.data)   
			    setFreePack(data.FREE_PACK)
          const mainData = data.data.map((plan:any, index:any) => {
            const isPopular = index === 0; // Example logic for isPopular
            const isBestValue = index === 1; // Example logic for isBestValue
            const discountedValue =plan.discountedValue
              // plan.discountPercent === "100"
                // ? plan.discountedValue
                // : (plan.originalValue * (100 - plan.discountPercent)) / 100;
          
            return {
              id: (index + 1).toString(),
              isPopular,
              isBestValue,
              isTopup: plan.isTopup,
              discountedValue: discountedValue.toString(),
              originalValue: plan.originalValue,
              discountPercent: plan.discountPercent,
              validity: plan.validity,
              balance: plan.balance,
              packageId: plan.packageId,
            };
          });
          setFinalWhatsappRechangePlan(filterData(mainData,activeFilters))
    
        } catch (error:any) {
          // Handle errors
        //   console.error("Error fetching responses:", error.response || error);
          throw error;
        }
      };

      useEffect(()=>{
        const filteredPlan = finalwhatsappRechangePlan.filter(
          (plan: any) => plan.packageId !== freePack
          );
// console.log("filteredPlans",filteredPlans)
    if (filteredPlan.length === 0) {
        setDefaultPackage(null); // No valid packages left
        return;
    }
        const minPackage = filteredPlan.reduce((prev: any, current: any) => {
          return parseFloat(prev.discountedValue || "0") <= parseFloat(current.discountedValue || "0")
            ? prev
            : current;
        });
        setDefaultPackage(minPackage)
         },[finalwhatsappRechangePlan,freePack])

          const [isGACalled, setIsGACalled] = useState<any>(false);

          useEffect(() => {
            if (!isGACalled && Array.isArray(roiDatesGA) && roiDatesGA.length > 1) {
              // console.log("roiDatesGA", roiDatesGA);
          
              if (user?.uid && user?.profile) {
                setIsGACalled(true);
                googleAnalytics(`freeTrialMarketingPage(${roiDatesGA[0]}${roiDatesGA[1]})`, user);
              }
            }
          }, [user, roiDatesGA, isGACalled]);
          


    const renderImage = (id: any) => {
        if (id === "bhkmsging") {
            return <img src={BulkMessageImage} alt="bulk-message" />
        } else if (id === "bluetick") {
            return <img src={BlueTickImage} alt="blue-tick" />
        } else if (id === "datasecurity") {
            return <img src={DataSecurityImage} alt="data-security" />
        } else if (id === "autosendmessages") {
            return <img src={AutoSendImage} alt="auto-send" />
        } else if (id === "messagetemplates") {
            return <img src={MessageTemplateImage} alt="message-template" />
        }
    }

    return (
        <div className={styles.MarketingBanner}>
            <div className={styles.Title}>Boost
                <div className={`flip-animate ${styles.MarketingFlip}`}>
                    <SplAnnouncement text={"Conversion"} classModifer={"amnime1"} />
                    <SplAnnouncement text={"Open Rate"} classModifer={"amnime2"} />
                    <SplAnnouncement text={"Buyer Response"} classModifer={"amnime3"} />
                </div>
            </div>
            <div className={styles.Subtitle}>with <span className={styles.TextGreenother}>WhatsApp</span> Bulk messages</div>
            <div className={styles.BannerText}>Send, schedule & track messages easily with built-in tools</div>
            <div className={styles.BannerActions}>
          {organizationData.WhatsAppTrialPack === true && (
            <span className={`${styles.Bannercta} ${styles.Filled}`} onClick={() => {
              if (Array.isArray(roiDatesGA) && roiDatesGA.length > 1) {
                pushToGA(
                  "event_tracking",
                  "read pro",
                  "read pro",
                  `whatsapp freeTrialMarketingPage(${roiDatesGA[0]}${roiDatesGA[1]}) | cta :Start Trial Now click`,
                  user,
                  // eventLabel ? eventLabel : ""
                )
              }
              readproPackagePurchaseViaPGI(user.user_super_oid, freePack, dispatcher, false);
            }}>Start Your Trial for just <span className={styles.Rupees}>&#8377;</span> 1</span>
          )}
                <span className={`${styles.Bannercta} ${styles.Outlined}`} onClick={() => {
                                    if (Array.isArray(roiDatesGA) && roiDatesGA.length > 1) {
                                      pushToGA(
                                        "event_tracking",
                                        "read pro",
                                        "read pro",
                                        `whatsapp freeTrialMarketingPage(${roiDatesGA[0]}${roiDatesGA[1]}) | cta :explore packages`,
                                        user,
                                        // eventLabel ? eventLabel : ""
                                      )
                                    }
                                    history.push("/whatsappRechargePlans", { isTrialPage: true })
                                  }}>Explore Plans</span>
            </div>
            {organizationData.WhatsAppTrialPack === true && (<div className={styles.BannerNoteText}>Only <span className={styles.Rupees}>&#8377;</span>{defaultPackage?.discountedValue}+GST per month after trial ends. cancel anytime</div>)}
            <div className={styles.MarketingBenefits}>
                <div className={styles.Title}><span className={styles.TextGreen}>What you get</span> with WhatsApp Marketing?</div>
                <div className={styles.MarketingBenfList}>
                    {
                        marketingBenfList?.map((item, index) => {
                            return (
                                <div className={styles.MarketingBenfItm} key={index}>
                                    <div className={styles.MarketingBenfImg}>
                                        {renderImage(item.id)}
                                    </div>
                                    <div className={styles.MarketingBenfCont}>
                                        <div className={styles.MarketingBenfTitle}>{item.title}</div>
                                        <div className={styles.MarketingBenfText}>{item.text}</div>
                                        {item.spltext &&
                                            <div className={styles.MarketingBenfsplText}>{item.spltext}</div>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
      user: state.user.data,
      organizationData: state.organization.organizationData,
      freeTrialPackage:state.utils.freeTrialPackage,
    };
  };

export default connect(mapStateToProps)(MarketingScreenBanner)

export const SplAnnouncement = ({ text, classModifer }: { text: any, classModifer: any }) => {

    return (
        <>
            {
                <div className={`pdp__splannuce--text ${classModifer}`}>
                    {text}
                </div>
            }
        </>
    )
}


export const marketingBenfList = [
    {
        id: "bhkmsging",
        title: "Bulk messaging",
        text: "Schedule or send instantly with a click"
    },
    {
        id: "bluetick",
        title: "Blue Tick",
        text: "Verified business account",
        spltext: "*Subject to Meta approval",
    },
    {
        id: "datasecurity",
        title: "Data security",
        text: "with end-to-end data encryption"
    },
    {
        id: "autosendmessages",
        title: "Autosend Messages",
        text: "on updating lead status"
    },
    {
        id: "messagetemplates",
        title: "Message templates",
        text: "Real Estate focused for error free, fast response"
    },
]